import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  // Note: Using console.error here because this runs before Angular DI is initialized,
  // so LoggingService is not available yet.
  console.error(err)
);
